import { CmxOptionComponent } from '../components/cmx-option/cmx-option.component';

export class CmxOptionSelectEvent {
    constructor(public source: CmxOptionComponent, public isUserInput: boolean = false) {
        //
    }
}
